module.exports = __webpack_public_path__ + "static/media/harold.4fedb406.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faces/harold.jpg
// module id = 523
// module chunks = 0